import { render, staticRenderFns } from "./addAProcess.vue?vue&type=template&id=a8be93f2&scoped=true&"
import script from "./addAProcess.vue?vue&type=script&lang=js&"
export * from "./addAProcess.vue?vue&type=script&lang=js&"
import style0 from "./addAProcess.vue?vue&type=style&index=0&id=a8be93f2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8be93f2",
  null
  
)

export default component.exports